import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import axios from 'axios'
import store from './store'
import VueElementLoading from 'vue-element-loading'
import ServerError from './layout/500'
import PageLoader from './components/PageLoader'
import ImageLoader from './components/ImageLoader'
import OtpInput from "@bachdgvn/vue-otp-input";
import VueSocialSharing from 'vue-social-sharing'
export const eventBus = new Vue(); // creating an event bus.
Vue.use(VueSocialSharing);
Vue.component("v-otp-input", OtpInput);
import 'viewerjs/dist/viewer.css'
import viewer from 'v-viewer'
Vue.use(viewer)
import { VueEditor } from "vue2-editor";
Vue.component('VueEditor', VueEditor)
Vue.component('VueElementLoading', VueElementLoading)
Vue.component('ServerError', ServerError)
Vue.component('PageLoader', PageLoader)
Vue.component('ImageLoader', ImageLoader)
Vue.config.productionTip = false
axios.defaults.baseURL = 'http://13.232.126.64';
Vue.prototype.baseURL = "http://13.232.126.64"
Vue.prototype.mediaURLOld = "http://13.232.126.64/file/get/"
Vue.prototype.mediaURL = "http://13.232.126.64/file/get/"
// ////////////////ip/////yest////////////////

// axios.defaults.baseURL = 'http://testpakt.leopardtechlabs.in';
// Vue.prototype.baseURL = "http://testpakt.leopardtechlabs.in"
// Vue.prototype.mediaURLOld = "http://testpakt.leopardtechlabs.in/file/get/"
// Vue.prototype.mediaURL = "http://testpakt.leopardtechlabs.in/file/get/"

// axios.defaults.baseURL = 'http://192.168.51.176:5120';
// Vue.prototype.baseURL = "http://192.168.51.176:5120"
// Vue.prototype.mediaURLOld = "http://192.168.51.176:5120/file/get/"
// Vue.prototype.mediaURL = "http://192.168.51.176:5120/file/get/"

// Vue.prototype.mediaURL = "http://192.168.50.48:5120/u/"  
Vue.mixin({
  data() {
    return {
      webpSupported: true,
    };


  },

  created() {
    (async () => {
      // If browser doesn't have createImageBitmap, we can't use webp.
      if (!self.createImageBitmap) {
        this.webpSupported = false;
        return;
      }
      // Base64 representation of a white point image
      const webpData =
        "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=";
      // Retrieve the Image in Blob Format
      const blob = await fetch(webpData).then((r) => r.blob());
      // If the createImageBitmap method succeeds, return true, otherwise false
      this.webpSupported = await createImageBitmap(blob).then(
        () => true,
        () => false
      );
      if (this.webpSupported) {
        Vue.prototype.mediaURL = "http://13.232.126.64/file/get/";
        // Vue.prototype.mediaURL = "http://13.232.126.64/wp/";
      } else {
        Vue.prototype.mediaURL = "http://13.232.126.64/file/get/";
      }
    })();
  },
});

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
